interface PersistenceResult {
  error: unknown;
}

export async function persistOrderedUpdates<T>(
  items: readonly T[],
  update: (item: T) => PromiseLike<PersistenceResult>,
): Promise<void> {
  const results = await Promise.all(items.map(update));
  const error = results.find((result) => result.error)?.error;
  if (error) throw error;
}
